import * as React from "react";
import { Badge } from "../badge/badge.mjs";
import { EqualHeight } from "../equal-height/equal-height/equal-height.mjs";
import { Heading } from "../typography/heading/heading.mjs";
import { Icon } from "../icon/icon/icon.mjs";
import { Image } from "../image/image.mjs";
import { ProcessListContext } from "./process-list.mjs";
const ProcessListItem = (props) => {
  const { headingLevel } = React.useContext(ProcessListContext);
  const { children, className, elementRef, icon, index, image, title } = props;
  const BEM = () => {
    const classArray = ["process-list__item"];
    if (image) {
      classArray.push("process-list__item--with-image");
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const transitionDelay = "".concat((index || 0) * 500, "ms");
  return /* @__PURE__ */ React.createElement("li", { className: BEM(), ref: elementRef }, /* @__PURE__ */ React.createElement("div", { className: "process-list__item-inner" }, /* @__PURE__ */ React.createElement("div", { className: "process-list__item-header" }, /* @__PURE__ */ React.createElement("div", { className: "process-list__item-header-inner", style: { transitionDelay } }, /* @__PURE__ */ React.createElement(EqualHeight, { group: "process-list-icon" }, icon && /* @__PURE__ */ React.createElement(Icon, { modifiers: icon, className: "process-list__icon" }), image && /* @__PURE__ */ React.createElement(Image, { ...image, className: "process-list__image" })), title && /* @__PURE__ */ React.createElement(EqualHeight, { group: "process-list-title", className: "process-list__item-title-wrapper" }, /* @__PURE__ */ React.createElement(Heading, { level: headingLevel, className: "process-list__item-title h4 text-bold" }, title))), /* @__PURE__ */ React.createElement("div", { className: "process-list__badge-wrapper", style: { transitionDelay } }, /* @__PURE__ */ React.createElement(Badge, { text: index !== void 0 ? index + 1 : "", size: "large", purpose: "selected", "aria-hidden": true, responsiveSize: true }))), /* @__PURE__ */ React.createElement("div", { className: "process-list__content", style: { transitionDelay } }, children)));
};
export {
  ProcessListItem
};
